<ng-container
  *ngIf="{
    isAuth: isAuth$ | async,
    isInstructor: isInstructor$ | async,
    categories: categories$ | async,
    isLoading: isLoading$ | async,
    userAuthInfo: userAuthInfo$ | async
  } as vm"
>
  <!-- Temporary header -->
  <ng-container *ngIf="showTempHeader; else showPermanentHeader">
    <header class="z-50 w-full bg-white">
      <div class="container flex max-h-16 items-center justify-between gap-2 py-4 lg:gap-4">
        <div class="logo relative h-7 w-20 lg:w-24">
          <a routerLink="">
            <svg-icon src="@assets/images/logo.svg" class="block w-20 lg:w-24"></svg-icon>
          </a>
        </div>
        <div class="flex items-center gap-4">
          <div class="language relative" (ClickOutside)="handleClickOutsideTemp(1)">
            <div (click)="showDropdown(1)" class="flex cursor-pointer items-center gap-2">
              <svg-icon class="btn-icon text-slate-400" src="@assets/images/icons/globe.svg"></svg-icon>
              <span>{{ currentLang }}</span>
            </div>
            @if(isDropdown[1]){
            <div class="absolute right-0 top-10 flex flex-col bg-white p-1 shadow-md">
              @for (lang of supportLanguages;track lang) {
              <a (click)="changeLanguage(lang.code)" class="btn btn-white btn-sm hover:bg-primary-50 justify-start">
                {{ lang.name }}
              </a>
              }
            </div>
            }
          </div>
          @if(vm.userAuthInfo?.is_instructor){
          <button (click)="goToDashboard()" class="btn btn-primary btn-sm hidden md:block" i18n>Go to Dashboard</button>
          } @if(!vm.userAuthInfo?.is_instructor){
          <button (click)="goToTechSection()" class="btn btn-primary btn-sm hidden md:block" i18n>
            Teach on Thkee
          </button>
          }

          <div *ngIf="vm.isAuth" class="language relative" (ClickOutside)="handleClickOutsideTemp(2)">
            <div (click)="showDropdown(2)" class="flex cursor-pointer items-center gap-2">
              <thk-avatar
                class="ltr:ml-2 rtl:mr-2"
                [title]="vm.userAuthInfo?.fullname"
                [url]="vm.userAuthInfo?.photo_url"
              ></thk-avatar>
            </div>
            @if(isDropdown[2]){
            <div class="absolute top-11 flex min-w-52 flex-col bg-white p-1 shadow-md ltr:right-0 rtl:left-0">
              <div class="content max-h-[400px] overflow-y-auto">
                <ul class="account-items block border-b border-b-slate-200 md:hidden">
                  <li class="relative p-3">
                    @if(vm.userAuthInfo?.is_instructor){
                    <button (click)="goToDashboard()" class="btn btn-primary btn-sm w-full" i18n>
                      Go to Dashboard
                    </button>
                    } @if(!vm.userAuthInfo?.is_instructor){
                    <button (click)="goToTechSection()" class="btn btn-primary btn-sm w-full" i18n>
                      Teach on Thkee
                    </button>
                    }
                  </li>
                </ul>
                <ul class="account-items">
                  <li class="relative">
                    <a routerLink="/student/account/profile" i18n>Account Settings</a>
                  </li>
                  <li class="relative">
                    <a class="rounded-b-lg cursor-pointer" (click)="logout()" i18n>Logout</a>
                  </li>
                </ul>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </header>
  </ng-container>
  <ng-template #showPermanentHeader>
    <!-- Header -->
    <!-- Preview Header -->
    <header *ngIf="isPreviewCourse" class="fixed z-50 w-full bg-white shadow">
      <div class="container flex max-h-16 items-center justify-between gap-2 py-4 lg:gap-4">
        <div class="logo relative h-7 w-20 lg:w-24" [ngClass]="{ 'hidden sm:block': showSearchBar }">
          <a [routerLink]="homeUrl">
            <svg-icon src="@assets/images/logo.svg" class="block w-20 lg:w-24"></svg-icon>
          </a>
        </div>
        <ng-container *ngIf="vm.isAuth">
          <div class="flex items-center gap-4">
            <a
              href="#"
              routerLink="/instructor/course/{{ params['course_slug'] }}/{{ queryParams['from'] }}"
              class="btn btn-sm bg-black text-white hover:bg-black"
            >
              <svg-icon class="btn-icon h-6 w-6" src="@assets/images/icons/arrow-left.svg"></svg-icon>
              <span class="block max-sm:hidden" i18n>Back to Instructor</span>
            </a>
            <thk-avatar class="ltr:ml-2 rtl:mr-2" [title]="user?.fullname" [url]="user?.photo_url"></thk-avatar>
          </div>
        </ng-container>
      </div>
    </header>
    <!-- Public Header -->
    <header *ngIf="!isPreviewCourse" class="fixed z-50 w-full bg-white shadow">
      <div class="container flex max-h-16 items-center gap-2 py-4 lg:gap-4">
        <div class="menu-btn md:hidden">
          <button class="btn btn-transparent btn-sm px-0" (click)="mobileNav.open()">
            <svg-icon class="btn-icon h-6 w-6" src="@assets/images/icons/bars-3.svg"></svg-icon>
          </button>
        </div>
        <div class="logo relative h-7 w-20 lg:w-24" [ngClass]="{ 'hidden sm:block': showSearchBar }">
          <a [routerLink]="homeUrl">
            <svg-icon src="@assets/images/logo.svg" class="block w-20 lg:w-24"></svg-icon>
          </a>
        </div>
        <div
          class="md:ar:border-l-0 md:ar:border-r ar:pl-0 ar:pr-4 flex grow basis-0 items-center gap-2 border-slate-200 pl-2 max-md:justify-end md:border-l md:border-r-0 lg:gap-4 lg:pl-4"
        >
          <ng-container *ngTemplateOutlet="category"></ng-container>
          <ng-container *ngTemplateOutlet="search"></ng-container>
          <ng-container *ngIf="vm.isLoading === 'loading'; else loadingProgress">
            <ng-container *ngTemplateOutlet="loader"></ng-container>
          </ng-container>
          <ng-template #loadingProgress>
            <ng-container *ngIf="!vm.isAuth; else accButtons">
              <ng-container *ngTemplateOutlet="publicAccButtons"></ng-container>
            </ng-container>
            <ng-container *ngIf="!vm.isAuth">
              <ng-container *ngTemplateOutlet="rightButtons"></ng-container>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </header>

    <ng-template #category>
      <!-- Menu -->
      <!-- <div class="category-menu hidden md:block">
        <div thkDropdown #testDropdown="thkDropdown" class="dropdown">
          <div class="button-container" thkDropdownToggle>
            <button class="btn btn-sm border-slate-100" type="button">
              <span i18n>Category</span>
              <svg-icon
                class="btn-icon transition-all"
                [class.rotate-180]="testDropdown.showing"
                src="@assets/images/icons/chevron-down.svg"
              ></svg-icon>
            </button>
          </div>
          <ul class="dropdown-menu rtl:!left-auto rtl:!overflow-visible" thkDropdownMenu>
            <div class="dropdown-container">
              <li *ngFor="let category of vm.categories" thkDropdownItem thkDropdown trigger="hover" placement="rb">
                <div class="w-full" thkDropdownToggle>
                  <a
                    uisref="marketplace"
                    [routerLink]="'/category/' + category.slug"
                    class="dropdown-item flex w-full items-center justify-between"
                  >
                    {{ category.name }}
                    <svg-icon
                      src="@assets/images/icons/chevron-right.svg"
                      class="ar:mr-auto ar:ml-0 ar:rotate-180 ml-auto"
                      *ngIf="category.subcategories?.length"
                    >
                    </svg-icon>
                  </a>
                  <ul
                    *ngIf="category.subcategories?.length"
                    thkDropdownMenu
                    class="dropdown-menu rtl:!absolute rtl:!-left-[266px]"
                  >
                    <li *ngFor="let sub_category of category.subcategories" class="" thkDropdownItem>
                      <a
                        uisref="marketplace"
                        [routerLink]="'/category/' + category.slug + '/' + sub_category.slug"
                        class="dropdown-item flex w-full items-center justify-between"
                      >
                        {{ sub_category.name }}
                        <svg-icon
                          src="@assets/images/icons/chevron-right.svg"
                          class="ml-auto"
                          *ngIf="sub_category.related_topics?.length"
                        ></svg-icon>
                      </a>
                      <ul
                        *ngIf="sub_category.related_topics?.length"
                        class="dropdown-subitems lg:group-hover/subChild:visible lg:group-hover/subChild:translate-y-0 lg:group-hover/subChild:opacity-100"
                      >
                        <li>
                          <div class="heading" i18n>Related Topics</div>
                        </li>
                        <li *ngFor="let topic of sub_category.related_topics">
                          <a
                            uisref="marketplace"
                            class="capitalize"
                            [routerLink]="'/category/' + category.slug + '/' + sub_category.slug + '/' + topic.slug"
                          >
                            <div>
                              <span>{{ topic.name }}</span>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div> -->
      <div class="category-menu">
        <div class="dropdown">
          <app-navigation #navigation position="left">
            <ng-container button>
              <button (click)="showDropdown(3)" class="btn btn-sm border-slate-100" type="button">
                <span i18n>Category</span>
                <svg-icon class="btn-icon transition-all" [class.rotate-180]="navigation.showDropdown" src="@assets/images/icons/chevron-down.svg"></svg-icon>
              </button>
            </ng-container>
            <ng-container content>
              <ul class="absolute  dropdown-menu rtl:!left-auto rtl:!overflow-visible">
                <div class="dropdown-container dropdown-container-v2">
                  <li *ngFor="let category of vm.categories">
                    <div class="w-full dropdown-item-v2">
                      <a uisref="marketplace" [routerLink]="'/category/' + category.slug" class="dropdown-item flex w-full items-center justify-between">
                        {{ category.name }}
                        <svg-icon src="@assets/images/icons/chevron-right.svg" class="ar:mr-auto ar:ml-0 ar:rotate-180 ml-auto" *ngIf="category.subcategories?.length"></svg-icon>
                      </a>
                      <ul *ngIf="category.subcategories?.length" class="dropdown-menu-v2 dropdown-menu rtl:!absolute rtl:!-left-[266px]">
                        <li *ngFor="let sub_category of category.subcategories" class="">
                          <a uisref="marketplace" [routerLink]="'/category/' + category.slug + '/' + sub_category.slug" class="dropdown-item flex w-full items-center justify-between">
                            {{ sub_category.name }}
                            <svg-icon src="@assets/images/icons/chevron-right.svg" class="ml-auto" *ngIf="sub_category.related_topics?.length"></svg-icon>
                          </a>
                          <ul *ngIf="sub_category.related_topics?.length"
                            class="dropdown-subitems lg:group-hover/subChild:visible lg:group-hover/subChild:translate-y-0 lg:group-hover/subChild:opacity-100">
                            <li>
                              <div class="heading" i18n>Related Topics</div>
                            </li>
                            <li *ngFor="let topic of sub_category.related_topics">
                              <a uisref="marketplace" class="capitalize" [routerLink]="'/category/' + category.slug + '/' + sub_category.slug + '/' + topic.slug">
                                <span>{{ topic.name }}</span>
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                </div>
              </ul>
            </ng-container>
          </app-navigation>
        </div>
      </div>
    </ng-template>

    <ng-template #search>
      <!-- Search -->
      <div class="hidden grow justify-center lg:flex">
        <div class="input-group input-group-sm w-full max-w-[400px]">
          <div class="group">
            <svg-icon src="@assets/images/icons/search.svg"></svg-icon>
            <input
              i18n-placeholder
              placeholder="Search courses"
              type="text"
              [(ngModel)]="searchKeyword"
              (keyup.enter)="onSearch($event)"
            />
          </div>
        </div>
      </div>
      <div class="search-btn hidden md:block lg:hidden" *ngIf="!showSearchBar">
        <button class="btn btn-transparent btn-sm px-2.5" (click)="showSearchBar = !showSearchBar">
          <svg-icon class="btn-icon" src="@assets/images/icons/search.svg"></svg-icon>
        </button>
      </div>
    </ng-template>

    <ng-template #searchMobile>
      <div class="flex items-center gap-0 md:gap-2">
        <div class="input-group input-group-sm w-full">
          <div class="group">
            <svg-icon src="@assets/images/icons/search.svg"></svg-icon>
            <input
              i18n-placeholder
              placeholder="Search courses"
              type="text"
              [(ngModel)]="searchKeyword"
              (keyup.enter)="onSearch($event)"
            />
          </div>
        </div>
        <button class="btn btn-transparent btn-sm px-2.5" (click)="showSearchBar = !showSearchBar">
          <svg-icon class="btn-icon" src="@assets/images/icons/x-mark.svg"></svg-icon>
        </button>
      </div>
    </ng-template>

    <ng-template #publicAccButtons>
      <!-- Account Buttons -->
      <div class="hidden grow md:block" *ngIf="!showSearchBar">
        <div class="flex items-center justify-end gap-2 sm:gap-3 lg:grow-0">
          <button class="btn btn-sm border-transparent" routerLink="/become-an-instructor">
            <span i18n>Teach on Thkee</span>
          </button>
          <button type="button" (click)="signup()" class="btn btn-sm btn-outline color-gray">
            <span class="lg:hidden" i18n>Register</span>
            <span class="hidden lg:block" i18n>Create Account</span>
          </button>
          <button type="button" (click)="login()" class="btn btn-primary btn-sm">
            <span i18n>Login</span>
          </button>
        </div>
      </div>
      <div class="search-mobile-container fadeIn grow" *ngIf="showSearchBar">
        <ng-container *ngTemplateOutlet="searchMobile"></ng-container>
      </div>
    </ng-template>

    <ng-template #accButtons>
      <!-- Account Buttons -->
      <div class="search-mobile-container fadeIn grow" *ngIf="showSearchBar">
        <ng-container *ngTemplateOutlet="searchMobile"></ng-container>
      </div>
      <div
        class="fadeIn grow lg:grow-0"
        [class.grow-0]="showSearchBar"
        [ngClass]="{ 'hidden sm:block': showSearchBar }"
      >
        <div class="flex items-center justify-end gap-2 sm:gap-3">
          <div *ngIf="!showSearchBar" class="fadeIn hidden items-center gap-3 md:flex">
            <a routerLink="/become-an-instructor" *ngIf="!vm.userAuthInfo?.is_instructor">
              <button class="btn btn-sm border-transparent">
                <span i18n>Become an Instructor</span>
              </button>
            </a>
            <a routerLink="/instructor" *ngIf="vm.userAuthInfo?.is_instructor">
              <button class="btn btn-sm border-transparent">
                <span i18n>Switch to Instructor</span>
              </button>
            </a>
            <button class="btn btn-sm border-transparent" routerLink="/student">
              <span i18n>Learning lab</span>
            </button>
          </div>
          <a class="hover:text-primary p-1.5 md:hidden" (click)="showSearchBar = !showSearchBar" *ngIf="!showSearchBar">
            <svg-icon class="h-5 w-5" src="@assets/images/icons/search.svg"></svg-icon>
          </a>
          <a routerLink="/cart" class="hover:text-primary relative p-1.5">
            <svg-icon class="h-5 w-5" src="@assets/images/icons/cart.svg"></svg-icon>
            <div
              *ngIf="cartCount"
              class="absolute -right-1 -top-1 inline-flex h-5 w-5 items-center justify-center rounded-full border-2 border-white bg-red-700 text-xs text-white"
            >
              {{ cartCount }}
            </div>
          </a>

          <!-- Menu -->
          <div class="account-menu">
            <app-navigation position="right">
              <ng-container button>
                <thk-avatar
                  class="ltr:ml-2 rtl:mr-2"
                  [title]="vm.userAuthInfo?.fullname"
                  [url]="vm.userAuthInfo?.photo_url"
                ></thk-avatar>
              </ng-container>
              <ng-container header>
                <div class="heading flex items-center gap-4 p-4">
                  <thk-avatar
                    sizeClasses="h-10 w-10"
                    [title]="vm.userAuthInfo?.fullname"
                    [url]="vm.userAuthInfo?.photo_url"
                  ></thk-avatar>

                  <ng-container *ngIf="user">
                    <div>
                      <div class="name font-medium">{{ user.fullname }}</div>
                      <div class="email text-xs text-slate-500">{{ user.email }}</div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <ng-container content>
                <div class="content max-h-[400px] overflow-y-auto border-y border-y-slate-300">
                  <ul class="account-items border-b border-b-slate-300">
                    <li *ngIf="vm.isAuth" class="relative">
                      <a
                        routerLink="/student/dashboard"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        i18n
                        >Learning lab</a
                      >
                    </li>
                    <li class="relative">
                      <a routerLink="/cart" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" i18n
                        >My cart</a
                      >
                    </li>
                    <li class="relative">
                      <a
                        routerLink="/student/wishlist"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        i18n
                        >Wishlist</a
                      >
                    </li>
                    <li *ngIf="vm.userAuthInfo?.is_instructor" class="relative">
                      <a
                        routerLink="/instructor/courses"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        i18n
                        >Instructor dashboard</a
                      >
                    </li>
                  </ul>
                  <ul class="account-items border-b border-b-slate-300">
                    <li class="relative">
                      <a
                        routerLink="/student/account/notifications"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        i18n
                        >Notifications</a
                      >
                    </li>
                    <!-- <li class="relative">
                    <a href="/search?category__slug=syndicate-front-end-deliverables" i18n>Messages</a>
                  </li> -->
                    <li class="relative">
                      <a
                        routerLink="/student/account/profile"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        i18n
                        >Account Settings</a
                      >
                    </li>
                    <li class="relative">
                      <a
                        routerLink="/student/account/payment-methods"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        i18n
                        >Payment Methods</a
                      >
                    </li>
                    <li class="relative">
                      <a
                        routerLink="/student/purchase/history"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        i18n
                        >Purchase history</a
                      >
                    </li>
                  </ul>
                  <ul class="account-items">
                    <!-- <li *ngIf="vm.userAuthInfo?.is_instructor" class="relative">
                    <a href="" [routerLink]="'/instructor-profile/' + user?.id" i18n>Public profile</a>
                  </li> -->
                    <li class="relative">
                      <a routerLink="/student/account/profile" [queryParams]="{edit: true}" i18n>Edit profile</a>
                    </li>
                  </ul>
                </div>
              </ng-container>
              <ng-container footer>
                <div class="footer">
                  <ul class="account-items">
                    <li class="relative">
                      <a href="http://support.thkee.com/" target="_blank" i18n>Help</a>
                    </li>
                    <li class="relative">
                      <a class="rounded-b-lg cursor-pointer" (click)="logout()" i18n>Logout</a>
                    </li>
                  </ul>
                </div>
              </ng-container>
            </app-navigation>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #rightButtons>
      <!-- Search -->
      <div
        class="flex items-center justify-start gap-2 border-slate-200 ltr:pl-2 ltr:pr-2 ltr:md:border-l ltr:lg:pl-3 rtl:md:border-r rtl:lg:pr-3"
        [ngClass]="{ 'hidden sm:flex': showSearchBar }"
      >
        <div class="flex items-center justify-start gap-2 lg:gap-3">
          <a class="hover:text-primary p-1.5 md:hidden" (click)="showSearchBar = !showSearchBar">
            <svg-icon class="h-5 w-5" src="@assets/images/icons/search.svg"></svg-icon>
          </a>
          <a routerLink="/cart" class="hover:text-primary relative p-1.5">
            <svg-icon class="h-5 w-5" src="@assets/images/icons/cart.svg"></svg-icon>
            <div
              *ngIf="cartCount"
              class="absolute -right-1 -top-1 inline-flex h-5 w-5 items-center justify-center rounded-full border-2 border-white bg-red-700 text-xs text-white"
            >
              {{ cartCount }}
            </div>
          </a>
          <a href="#" class="hover:text-primary hidden rounded border border-slate-200 p-1.5 md:block">
            <svg-icon class="h-5 w-5" src="@assets/images/icons/globe.svg"></svg-icon>
          </a>
        </div>
      </div>
    </ng-template>

    <common-modal
      #mobileNav
      i18n-title
      title=""
      customClass="mobile-nav w-full max-w-[70%] overflow-visible rounded-none"
      alignment="left"
    >
      <ng-container header>
        <div class="fadeIn bg-slate-100" *ngIf="selectedCtg">
          <a class="block px-6 py-3.5 text-sm" (click)="selectedCtg = selectedCtg != 'all' ? 'all' : ''">
            <div class="flex items-center justify-start gap-3">
              <svg-icon class="block h-4 w-4" src="@assets/images/icons/chevron-left.svg"></svg-icon>
              <span i18n>Menu</span>
            </div>
          </a>
        </div>

        <div class="fadeIn p-6" *ngIf="!selectedCtg">
          <div class="logo relative h-7 w-28">
            <a [routerLink]="homeUrl">
              <svg-icon src="@assets/images/logo.svg" class="block w-28"></svg-icon>
            </a>
          </div>
        </div>
        <button
          class="btn btn-white btn-sm absolute -right-9 top-1 h-8 w-8 rounded-full px-2"
          (click)="mobileNav.close()"
        >
          <svg-icon class="btn-icon" src="@assets/images/icons/x-mark.svg"></svg-icon>
        </button>
      </ng-container>
      <ng-container content>
        <div class="px-6 text-sm tracking-wider">
          <div *ngIf="!selectedCtg" class="fadeIn">
            <div class="flex flex-col gap-2.5 py-6">
              <ng-container *ngIf="!vm.isAuth">
                <a (click)="login()" i18n>Log in</a>
                <a (click)="signup()" i18n>Sign up</a>
              </ng-container>
              <ng-container *ngIf="vm.isAuth">
                <a
                  routerLink="/instructor/register"
                  *ngIf="!vm.userAuthInfo?.is_instructor"
                  (click)="mobileNav.close()"
                  i18n
                  >Become an Instructor</a
                >
                <a routerLink="/instructor" *ngIf="vm.userAuthInfo?.is_instructor" (click)="mobileNav.close()" i18n
                  >Switch to Instructor</a
                >
                <a routerLink="/student" (click)="mobileNav.close()" i18n>Learning lab</a>
              </ng-container>
            </div>
            <div class="border-y border-slate-300 py-6">
              <div class="mb-2.5 text-xs font-bold" i18n>Most Popular</div>
              <ul class="flex flex-col gap-2.5" *ngIf="vm.categories">
                <ng-container *ngFor="let category of mostPopular(vm.categories)">
                  <li class="flex items-center justify-between">
                    <a [routerLink]="'category/' + category.slug" (click)="mobileNav.close()">{{ category.name }}</a>
                    <a (click)="selectedCtg = category.id" class="pl-5" *ngIf="category.subcategories?.length">
                      <svg-icon class="block h-4 w-4" src="@assets/images/icons/chevron-right.svg"></svg-icon>
                    </a>
                  </li>
                </ng-container>

                <li class="flex items-center justify-between">
                  <a (click)="selectedCtg = 'all'" i18n>All categories</a>
                  <a (click)="selectedCtg = 'all'" class="pl-5">
                    <svg-icon class="block h-4 w-4" src="@assets/images/icons/chevron-right.svg"></svg-icon>
                  </a>
                </li>
              </ul>
            </div>
            <div class="flex flex-col gap-2.5 py-6">
              <div class="text-xs font-bold" i18n>More from Thkee</div>
              <a href="#" i18n>Help</a>
            </div>
          </div>
          <div *ngIf="selectedCtg" class="fadeIn">
            <div class="py-6">
              <div class="mb-2.5 text-xs font-bold">{{ selectedCtg !== 'all' ? '' : ctgLabel }}</div>
              <ul class="flex flex-col gap-2.5" *ngIf="vm.categories">
                <ng-container *ngFor="let category of filterCategory(vm.categories)">
                  <li class="flex items-center justify-between">
                    <a [routerLink]="'category/' + category.slug" (click)="mobileNav.close()">{{ category.name }}</a>
                    <a (click)="selectedCtg = category.id" class="pl-5" *ngIf="category.subcategories?.length">
                      <svg-icon class="block h-4 w-4" src="@assets/images/icons/chevron-right.svg"></svg-icon>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>
      </ng-container>
    </common-modal>

    <ng-template #loader>
      <div class="flex flex-row items-center gap-8">
        <span class="h-5 w-32 animate-pulse bg-slate-300"></span>
        <span class="h-5 w-32 animate-pulse bg-slate-300"></span>
        <span class="h-9 w-9 animate-pulse rounded-full bg-slate-300"></span>
      </div>
    </ng-template>
  </ng-template>
</ng-container>
